<template>
    <Modal :value="showModal"
           title="Game Details"
           width="800"
           :closable="false"
           :mask-closable="false"
           @on-visible-change="onVisibleChange">
        <div>
            <Row :gutter="32">
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Title:</label>
                        <span v-if="gameData.gameRef.gameTitle">{{gameData.gameRef.gameTitle}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Title:</label>
                        <span v-if="gameData.gameRef.author">{{gameData.gameRef.author}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Description:</label><br>
                        <span v-if="gameData.description">{{gameData.description}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Date Published:</label><br>
                        <span v-if="gameData.datePublished">{{gameData.datePublished}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Trigger:</label>
                        <span v-if="gameData.Trigger">{{gameData.Trigger}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Version:</label>
                        <span v-if="gameData.version">{{gameData.version}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Level:</label>
                        <span v-if="gameData.level">{{gameData.level}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Downloads:</label>
                        <span v-if="gameData.downloads">{{gameData.downloads}}</span>
                        <span v-else>N/A</span>
                    </div>
                </i-col>
                <i-col :xs="12" style="margin: 24px auto;">
                    <div class="info-box">
                        <Table :columns="trophyColumns" width="350" :data="gameData.trophies">
                            <p slot-scope="{ row, index }" slot="trophyName">
                                '{{row.trophyName}}' in '{{row.tournamentName}}'
                            </p>
                        </Table>
                    </div>
                </i-col>
                <i-col :xs="12" style="margin: 24px auto;">
                    <div class="info-box">
                        <Table :columns="likeColumns" width="350" :data="gameData.likes">
                            <p slot-scope="{ row, index }" slot="like">
                                {{row}}
                            </p>
                        </Table>
                    </div>
                </i-col>
            </Row>
        </div>
        <div slot="footer">
            <Button @click="showModal=false">Close</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        data() {
            return {
                showModal: false,
                gameData:{
                    gameRef: {
                        gameTitle: "",
                        author: ""
                    },
                    description: "",
                    trigger: null,
                    datePublished: "",
                    version: null,
                    level: null,
                    downloads: null,
                    domain: "",
                    likes: [],
                    trophies: []
                },
                trophyColumns: [
                    {
                        title: "Trophies",
                        slot: "trophyName"
                    },
                ],
                likeColumns: [
                    {
                        title: "Likes",
                        slot: "like"
                    },
                ],
            };
        },
        methods: {
            triggerModal(game) {
                this.showModal = true;
                this.gameData=game
            },
            onVisibleChange(val){
                if(!val) {
                    this.gameData={
                        gameRef: {
                            gameTitle: "",
                                author: ""
                        },
                        description: "",
                            trigger: null,
                            datePublished: "",
                            version: null,
                            level: null,
                            downloads: null,
                            domain: "",
                            likes: [],
                            trophies: []
                    }
                }
            }
        }
    };
</script>
<style scoped>
    .info-box{
        margin-top: 16px;
    }
    .info-box>*{
        display: inline-block;
        vertical-align: middle;
    }
    .info-box label{
        font-weight: 600;
        margin-right: 8px;
    }
</style>
